import type { ResourceConfig } from "../types";

export const workCalendarConfig = {
  displayName: "工作日历",
  category: "attendance",
  permissions: {
    "read:all": {
      label: "查看工作日历",
      description: "可以查看全局和教练工作日历",
    },
    "write:global": {
      label: "维护全局日历",
      description: "可以维护法定假日和调休补班",
    },
    "write:coach:all": {
      label: "维护教练日历",
      description: "可以维护任意教练的工作时段和手动日历覆盖",
    },
  },
} satisfies ResourceConfig;
